import { Helmet } from "react-helmet-async";

const SITE_URL = "https://transferavellino.com";

/* Schema.org LocalBusiness - core entity for GEO/AIO */
const localBusiness = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": `${SITE_URL}/#business`,
  name: "Transfer Avellino",
  alternateName: "Transfer Avellino NCC",
  description: "Servizio di noleggio con conducente (NCC) premium ad Avellino. Transfer aeroportuali, transfer stazioni, eventi, business travel e tour personalizzati in Campania.",
  url: SITE_URL,
  telephone: "+393784035054",
  email: "info@transferavellino.com",
  image: "https://customer-assets.emergentagent.com/job_luxury-ride-avellino/artifacts/b7diefut_ncc-avellino.png",
  logo: "https://customer-assets.emergentagent.com/job_luxury-ride-avellino/artifacts/v2iwkqbg_N.C.C.svg",
  priceRange: "$$$$",
  currenciesAccepted: "EUR",
  paymentAccepted: "Contanti, Carte di Credito, Apple Pay, Google Pay, PayPal, Klarna",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Avellino",
    addressRegion: "Campania",
    addressCountry: "IT",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 40.9146076,
    longitude: 14.7715835,
  },
  areaServed: [
    { "@type": "City", name: "Avellino" },
    { "@type": "City", name: "Napoli" },
    { "@type": "City", name: "Salerno" },
    { "@type": "City", name: "Roma" },
    { "@type": "AdministrativeArea", name: "Campania" },
    { "@type": "AdministrativeArea", name: "Costiera Amalfitana" },
  ],
  openingHoursSpecification: {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    opens: "00:00",
    closes: "23:59",
  },
  sameAs: [],
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "5",
    reviewCount: "47",
    bestRating: "5",
    worstRating: "1",
  },
};

/* Services schema */
const services = [
  {
    "@type": "Service",
    name: "Transfer Aeroportuali Avellino",
    description: "Servizio transfer da e per aeroporti di Napoli Capodichino, Roma Fiumicino e Ciampino. Monitoraggio voli, accoglienza con cartellino, assistenza bagagli.",
    provider: { "@id": `${SITE_URL}/#business` },
    areaServed: "Campania, Italia",
    serviceType: "Transfer Aeroportuale NCC",
  },
  {
    "@type": "Service",
    name: "Transfer Stazioni Avellino",
    description: "Servizio transfer puntuale da e per stazioni ferroviarie della Campania. Alta Velocita, Intercity e regionali.",
    provider: { "@id": `${SITE_URL}/#business` },
    areaServed: "Campania, Italia",
    serviceType: "Transfer Stazione NCC",
  },
  {
    "@type": "Service",
    name: "NCC Eventi e Cerimonie Avellino",
    description: "Noleggio con conducente per matrimoni, battesimi, gala e cerimonie. Veicoli di lusso decorabili, autisti in abito formale.",
    provider: { "@id": `${SITE_URL}/#business` },
    areaServed: "Campania, Italia",
    serviceType: "NCC Cerimonie",
  },
  {
    "@type": "Service",
    name: "Business Travel NCC Avellino",
    description: "Servizio trasporto executive per professionisti. Wi-Fi a bordo, massima riservatezza, fatturazione aziendale.",
    provider: { "@id": `${SITE_URL}/#business` },
    areaServed: "Italia",
    serviceType: "NCC Business",
  },
  {
    "@type": "Service",
    name: "Tour Personalizzati Campania",
    description: "Tour su misura per Costiera Amalfitana, Pompei, Reggia di Caserta, Paestum. Autista-guida disponibile, itinerari personalizzabili.",
    provider: { "@id": `${SITE_URL}/#business` },
    areaServed: "Campania, Italia",
    serviceType: "Tour NCC",
  },
];

/* FAQ schema for AIO/GEO */
const faq = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "Quanto costa un transfer da Avellino all'aeroporto di Napoli?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Il costo del transfer da Avellino all'aeroporto di Napoli Capodichino varia in base al tipo di veicolo e al numero di passeggeri. Offriamo tariffe fisse e trasparenti con preventivo personalizzato gratuito. Contattateci al +39 378 4035054 o richiedete un preventivo online.",
      },
    },
    {
      "@type": "Question",
      name: "Il servizio NCC Transfer Avellino e' disponibile H24?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Si, Transfer Avellino e' operativo 24 ore su 24, 7 giorni su 7, inclusi festivi. Siamo sempre disponibili per transfer aeroportuali notturni, eventi serali e qualsiasi esigenza di trasporto.",
      },
    },
    {
      "@type": "Question",
      name: "Quali veicoli sono disponibili per il noleggio con conducente?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "La nostra flotta include veicoli Mercedes e BMW di ultima generazione: berline di lusso (Classe E, Classe S), van premium (V-Class) per gruppi fino a 7 persone, e veicoli executive. Tutti i veicoli sono costantemente igienizzati e mantenuti.",
      },
    },
    {
      "@type": "Question",
      name: "Come posso prenotare un transfer ad Avellino?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Potete prenotare in diversi modi: telefonicamente al +39 378 4035054, tramite WhatsApp, compilando il modulo di prenotazione sul nostro sito web, o inviando una email a info@transferavellino.com. Vi risponderemo con un preventivo personalizzato in tempi brevissimi.",
      },
    },
    {
      "@type": "Question",
      name: "Transfer Avellino effettua tour sulla Costiera Amalfitana?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Si, offriamo tour personalizzati sulla Costiera Amalfitana, Pompei, Reggia di Caserta, Paestum e in tutta la Campania. I nostri autisti conoscono ogni angolo del territorio e possono creare itinerari su misura con soste fotografiche incluse.",
      },
    },
    {
      "@type": "Question",
      name: "Quali metodi di pagamento accettate?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Accettiamo tutti i principali metodi di pagamento: contanti, carte di credito e debito (Visa, Mastercard, American Express), Apple Pay, Google Pay, PayPal, Klarna e bonifico bancario per prenotazioni aziendali.",
      },
    },
  ],
};

/* WebSite schema for sitelinks search */
const webSite = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Transfer Avellino",
  url: SITE_URL,
  description: "Servizio NCC premium ad Avellino - Noleggio con conducente per aeroporti, stazioni, eventi e tour in Campania",
  potentialAction: {
    "@type": "SearchAction",
    target: `${SITE_URL}/servizi`,
    "query-input": "required name=search_term_string",
  },
};

/* BreadcrumbList helper */
function breadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: item.name,
      item: `${SITE_URL}${item.path}`,
    })),
  };
}

export function HomeStructuredData() {
  const schema = [
    { ...localBusiness, "@context": "https://schema.org" },
    webSite,
    faq,
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "Servizi NCC Transfer Avellino",
      itemListElement: services.map((s, i) => ({
        "@type": "ListItem",
        position: i + 1,
        item: s,
      })),
    },
  ];

  return (
    <Helmet>
      {schema.map((s, i) => (
        <script key={s["@type"] || `schema-${i}`} type="application/ld+json">
          {JSON.stringify(s)}
        </script>
      ))}
    </Helmet>
  );
}

export function ChiSiamoStructuredData() {
  const schema = [
    breadcrumbSchema([
      { name: "Home", path: "/" },
      { name: "Chi Siamo", path: "/chi-siamo" },
    ]),
    {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      name: "Chi Siamo - Transfer Avellino",
      description: "Scopri la storia e i valori di Transfer Avellino, servizio NCC premium in Campania.",
      url: `${SITE_URL}/chi-siamo`,
      mainEntity: { "@id": `${SITE_URL}/#business` },
    },
  ];

  return (
    <Helmet>
      {schema.map((s, i) => (
        <script key={s["@type"] || `schema-${i}`} type="application/ld+json">
          {JSON.stringify(s)}
        </script>
      ))}
    </Helmet>
  );
}

export function ServiziStructuredData() {
  const schema = [
    breadcrumbSchema([
      { name: "Home", path: "/" },
      { name: "Servizi", path: "/servizi" },
    ]),
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "Servizi NCC Transfer Avellino",
      description: "Gamma completa di servizi di noleggio con conducente premium ad Avellino e in Campania.",
      url: `${SITE_URL}/servizi`,
      itemListElement: services.map((s, i) => ({
        "@type": "ListItem",
        position: i + 1,
        item: s,
      })),
    },
  ];

  return (
    <Helmet>
      {schema.map((s, i) => (
        <script key={s["@type"] || `schema-${i}`} type="application/ld+json">
          {JSON.stringify(s)}
        </script>
      ))}
    </Helmet>
  );
}

export function PrenotazioneStructuredData() {
  const schema = [
    breadcrumbSchema([
      { name: "Home", path: "/" },
      { name: "Prenota", path: "/prenota" },
    ]),
  ];

  return (
    <Helmet>
      {schema.map((s, i) => (
        <script key={s["@type"] || `schema-${i}`} type="application/ld+json">
          {JSON.stringify(s)}
        </script>
      ))}
    </Helmet>
  );
}

export function ContattiStructuredData() {
  const schema = [
    breadcrumbSchema([
      { name: "Home", path: "/" },
      { name: "Contatti", path: "/contatti" },
    ]),
    {
      "@context": "https://schema.org",
      "@type": "ContactPage",
      name: "Contatti Transfer Avellino",
      description: "Contatta Transfer Avellino per prenotazioni e informazioni sul servizio NCC.",
      url: `${SITE_URL}/contatti`,
      mainEntity: { "@id": `${SITE_URL}/#business` },
    },
  ];

  return (
    <Helmet>
      {schema.map((s, i) => (
        <script key={s["@type"] || `schema-${i}`} type="application/ld+json">
          {JSON.stringify(s)}
        </script>
      ))}
    </Helmet>
  );
}
